/**
 * A directive that, when placed within a FlexTable, will invoke the handler
 * whenever cell selection on the element occurs.
 * @example
 * <table apex-flex-table apex-excel-hotkeys="true">
 *   <tr><td apex-flex-select-cell="$ctrl.isSelected = $event.selected"></td></tr>
 * </table>
 * @example
 * // $event
 * {
 *   selected: true
 * }
 */
export function FlexSelectCellDirective() {
    return {
        selector: "apexFlexSelectCell",
        require: {
            flexTable: "^apexFlexTable"
        },
        link: function(scope, el, attr, { flexTable }) {
            const handler = args => {
                Object.assign(scope, args || {});
                scope.$eval(attr.apexFlexSelectCell);
            }
            // Add a handler to be invoked if the given element is selected.
            flexTable.context.addCellHandler("excelHotkeys", "select", el[0], handler);
            scope.$on("destroy", () => {
                if (flexTable) {
                    flexTable.context.removeCellHandler("excelHotkeys", "select", el[0], handler);
                }
            })
        }
    }
}
